import React from "react";
import { Header } from "@/components/Header";
import { ServiceQuickNav } from "@/components/ServiceQuickNav";
import { Hero } from "@/components/Hero";
import { ServicePillars } from "@/components/ServicePillars";
import { Founder } from "@/components/Founder";
import { Industries } from "@/components/Industries";
import { VizagGallery } from "@/components/VizagGallery";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { Toaster } from "@/components/ui/sonner";

const Landing = () => {
  return (
    <main className="min-h-screen bg-brand-bg text-white selection:bg-brand-primary selection:text-white">
      <Header />
      <ServiceQuickNav />
      <Hero />
      <div className="section-divider" />
      <ServicePillars />
      <div className="section-divider" />
      <Founder />
      <Industries />
      <VizagGallery />
      <ContactSection />
      <Footer />
      <FloatingWhatsApp />
      <Toaster
        position="bottom-left"
        toastOptions={{
          style: {
            background: "#12251B",
            color: "#F8FAFC",
            border: "1px solid #273F33",
          },
        }}
      />
    </main>
  );
};

export default Landing;
